import { Scene } from './Scene';
import { Game } from '../Game';

export type SceneConstructor = new (game: Game, props: unknown) => Scene;
type Scenes = {[key: string]: SceneConstructor};

export class SceneManager {
  private readonly scenes: Scenes;
  private readonly game: Game;
  private scene: Scene | null = null;

  constructor(game: Game, scenes: Scenes) {
    this.game = game;
    this.scenes = scenes;
  }

  public getScene(): Scene | null {
    return this.scene;
  }

  public update(dt: number): void {
    this.scene && this.scene.update(dt);
  }

  public handleResize(size: [number, number]): void {
    this.scene && this.scene.handleResize(size);
  }

  public startScene = (sceneKey: string, props?: unknown) => {
    const sceneConstructor = this.scenes[sceneKey];

    if (!sceneConstructor) {
      console.warn(`SceneManager: no scene ${sceneKey}`);
      return;
    }

    this.game.timeEvents.removeAll();
    this.game.tweens.removeAll();

    this.scene && this.scene.destroy();
    this.scene = new sceneConstructor(this.game, props);
    this.handleResize([this.game.screen.width, this.game.screen.height]);

    // @ts-ignore
    window.scene = this.scene;
  }
}
